<template>
	<div>
		<div>
			<kendo-multiselect
                :ref="'multiselect' + _uid"
				v-if="loaded"
				v-model="selected"
				:data-source="items"
				:data-text-field="textField"
				:data-value-field="valueField"
				:data-placeholder="$t('choose')"
				:filter="filterPattern"
				:readonly="readonly"
				@change="inputChanged"
				:name="'multiselect' + _uid"
				:data-vv-as="fieldName"
				v-validate="required ? 'required' : ''"
				:footer-template="nomDropdownSettings.showFooterTemplate ? footerTemplate : ''"
				:height="height"
				style="width: 100%;"
			/>
		</div>
		<span class="text-danger col-12" v-if="errors.has('multiselect' + _uid)">{{ errors.first('multiselect' + _uid) }}</span>

		<DropdownSettings
            v-if="loaded"
            :filterPattern.sync="filterPattern"
            :show.sync="showSettings"
        />
	</div>
</template>

<script>
import Vue from "vue";
import FooterTemplate from "@/components/grid/NomenclatureDropdownFooterTemplate";
import DropdownSettings from "@/components/common/DropdownSettings";
import { mapGetters } from "vuex";

export default {
	inject: ['$validator'],
	components: {
        DropdownSettings,
    },
	props: {
		value: [Number, String, Array],
		type: String,
		parentSort: {
			type: Number,
			default: 0
		},
		loadByParentSort: {
			type: Boolean,
			default: false
		},
        apiUrl: {
			type: String,
			required: false
		},
		// Името което показва vee-validate
		fieldName: {
			type: String,
			required: true,
		},
		required: {
			type: Boolean,
			default: false
		},
		isCity: {
			type: Boolean,
			default: false
		},
		readonly: {
			type: Boolean,
			default: false
		},
		height: {
            type: Number,
            default: 400, // 200 - Default value for Kendo DropdownList
        },
        valueField: {
            type: String,
            default() {
                return 'id'
            }
        },
        textField: {
            type: String,
            default() {
                return 'text'
            }
        },
	},
	data() {
		return {
			selected: this.value,
			loaded: false,
			showSettings: false,
            filterPattern: '',
			items: []
		};
	},
	methods: {
		loadItems() {
			let url = '';
            if (this.apiUrl) {
                url = this.apiUrl
            } else if (this.loadByParentSort) {
				url = `/api/search/GetNomenclatureItemsByParentSort?sort=${this.parentSort}&selected=${this.value}`;
			} else {
				url = `/api/search/GetNomenclatureItems?type=${this.type}&isCity=${this.isCity}&selected=${this.value}`;
			}

			this.$http.get(url).then(result => {
				this.items = result.data;
				this.$emit('change', this.value);
				this.loaded = true;
			});
		},
		inputChanged(event) {
			this.$emit('input', event.sender.value() /* this.selected */);
		},
        selectAll() {
            const multiSelect = this.$refs[`multiselect${this._uid}`];
            if (!multiSelect) return;

            const values = multiSelect.kendoWidget().dataSource.view().map(x => {
                if (x.hasOwnProperty(this.valueField)) {
                    return x[this.valueField];
                }
            });

            if (values) {
                this.selected = values;
                this.$emit('input', this.selected);
            }
        },
        unselectAll() {
            if (Array.isArray(this.selected)) {
                this.selected.splice(0);
            }
        },
		footerTemplate: function (e) {
            return {
                template: Vue.component(FooterTemplate.name, FooterTemplate),
                templateArgs: {
                    ...e,
                    btns: [
                        {
                            name: "selectAll",
                            text: this.$t("buttons.selectAll.btnText"),
                            tooltip: this.$t("buttons.selectAll.tooltipText"),
                            class: "btn btn-secondary",
                            icon: "far fa-check-square",
                            show: true,
                            clickHandler: this.selectAll,
                        },
                        {
                            name: "selunselectAllectAll",
                            text: this.$t("buttons.unselectAll.btnText"),
                            tooltip: this.$t("buttons.unselectAll.tooltipText"),
                            class: "btn btn-secondary",
                            icon: "far fa-square",
                            show: true,
                            clickHandler: this.unselectAll,
                        },
                        {
                            name: "multiSelectSettings",
                            text: this.$t("buttons.settings.btnText"),
                            tooltip: this.$t("buttons.settings.btnText"),
                            class: "btn btn-secondary",
                            icon: "fas fa-cog",
                            show: this.nomDropdownSettings.showSettings,
                            clickHandler: () => {
                                this.showSettings = true;
                            },
                        },
                    ],
                },
            };
        },
	},
	computed: {
        ...mapGetters(["nomDropdownSettings"]),
    },
	watch: {
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				// TODO: Not working because it binds to object not only for id
				this.selected = newVal;
			}
		}
	},
	mounted() {
		this.filterPattern = this.nomDropdownSettings.defaultFilterPattern;
		this.loadItems();
	}
};
</script>
